import React from 'react';
import PropTypes from 'prop-types';
import styles from './InputField.module.css';

const InputField = ({ id, label, value, onChange, readOnly, isDisabled = false, type = "text", className = "", tooltip = "", ...restProps }) => {
  // Componente de rótulo com tooltip, se especificado
  const renderLabelWithTooltip = () => (
    <div className={styles.labelContainer}>
      <label htmlFor={id}>{label}</label>
      {tooltip && (
        <div className={styles.tooltipContainer}>
          <span className={styles.infoIcon} aria-label="Informação adicional">i</span>
          <span className={styles.tooltipText}>{tooltip}</span>
        </div>
      )}
    </div>
  );

  return (
    <div className={styles.formGroup}>
      {renderLabelWithTooltip()}
      {type === "textarea" ? (
        <textarea
          id={id}
          className={`${styles.formControl} ${readOnly ? styles.readonlyField : ''} ${className}`}
          value={value}
          onChange={onChange}
          readOnly={readOnly}
          disabled={isDisabled}
          aria-disabled={isDisabled}
          {...restProps}
        />
      ) : (
        <input
          type={type}
          id={id}
          className={`${styles.formControl} ${readOnly ? styles.readonlyField : ''} ${className}`}
          value={type === 'date' && (!value || value === '') ? '2000-01-01' : value}
          onChange={onChange}
          readOnly={readOnly}
          disabled={isDisabled}
          aria-disabled={isDisabled}
          {...restProps}
        />
      )}
    </div>
  );
};

InputField.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.node.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func,
  readOnly: PropTypes.bool,
  isDisabled: PropTypes.bool,
  type: PropTypes.string,
  className: PropTypes.string,
  tooltip: PropTypes.string
};

InputField.defaultProps = {
  type: "text",
  className: "",
  readOnly: false,
  isDisabled: false,
  value: "",
  tooltip: ""
};

export default InputField;